import { render, staticRenderFns } from "./ReplyCard.vue?vue&type=template&id=4f7a3cd8&scoped=true"
import script from "./ReplyCard.vue?vue&type=script&lang=js"
export * from "./ReplyCard.vue?vue&type=script&lang=js"
import style0 from "./ReplyCard.vue?vue&type=style&index=0&id=4f7a3cd8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f7a3cd8",
  null
  
)

export default component.exports